export default "__VITE_ASSET__b32u0NpO__"